<template>
  <div class="home">
    <div class="text-center m-4 logo">
      <img
        src="../assets/images/logotipo.png"
        alt="logo_dominos"
        id="logo_dominos"
      />
    </div>
    <div class="box">
      <div class="header"></div>
      <div class="body">
        <div>
          <h2><i class="far fa-sad-tear"></i></h2>
          <p v-if="request_message">{{ request_message }}</p>
          <p v-else> Pesquisa inválida </p>
        </div>
      </div>
      <div class="footer"></div>
    </div>

    <!-- mobile -->

    <div class="card-wrapper">
      <div
        class="p-4 my-card"
        id="form"
      >
        <div>
          <div>
            <h2><i class="far fa-sad-tear"></i></h2>
            <p>Desculpe, infelizmente essa pesquisa não está mais válida.</p>
          </div>
        </div>
      </div>
      <!--card-->
    </div>
    <!--card-wrapper-->
  </div>
</template>
<script>

import { mapState } from "vuex";

export default {
  name: "OfflineSurvey",
  data() {
    return {

    }
  },
  computed: {
    ...mapState(["request_message"])
  }
}
</script>

<style scoped>
div.box {
  min-height: 700px;
  height: auto;
  max-width: 768px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
}

div.body > .title {
  position: relative;
  top: -20px;
}

div.box > .header {
  width: 100%;
  height: 59px;
  background-image: url("../assets/images/topo.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

div.box > .body {
  background: url("../assets/images/repeat-meio.png") repeat;
  width: 100%;
  flex: 1;
  padding: 20px 4%;
}

div.box > .footer {
  background: url("../assets/images/rodape.png") repeat;
  width: 100%;
  height: 59px;
}

.home {
  padding: 0 2%;
}

.questionAnimation-enter,
.questionAnimation-leave-to {
  opacity: 0;
}

.questionAnimation-enter {
  display: none;
}

.questionAnimation-enter {
  transform: translate3d(0, -20px, 0);
}

.questionAnimation-leave-to {
}

.questionAnimation-enter-active,
.questionAnimation-leave-active {
  transition: all 0.5s;
  display: none;
}

.questionAnimation-enter-active {
  display: block;
}

.questionAnimation-leave-active {
  transition-delay: 1s;
  transform: translate3d(0, 20px, 0);
}

.relationQuestionAnimation-enter,
.relationQuestionAnimation-leave-to {
  opacity: 0;
}

.relationQuestionAnimation-enter {
  transform: translate3d(0, -20px, 0);
}

.relationQuestionAnimation-leave-to {
  transform: translate3d(0, 20px, 0);
}

.relationQuestionAnimation-enter-active,
.relationQuestionAnimation-leave-active {
  transition: all 0.5s;
}

.my-card {
  max-width: 660px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  min-height: 700px;
  box-shadow: none;
  border: 2px solid #006491;
  border-radius: 0px;
}

.card-wrapper {
  max-width: 660px;
  margin: 0 auto;
  background-color: #fff;
  padding: 10px;
  margin-bottom: 20px;
  display: none;
}

@media screen and (max-width: 1050px) {
  div.box {
    display: none;
  }

  .card-wrapper {
    display: block;
  }

  .my-card {
    min-height: 0;
  }
}

@media screen and (max-width: 768px) {
  .my-card {
    max-width: 600px;
  }

  .card-wrapper {
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
  }
}

@media screen and (max-width: 680px) {
  .my-card {
    max-width: 100% !important;
    height: auto;
  }

  .card-wrapper {
    max-width: none;
    margin-bottom: 70px;
  }

  .logo img {
    max-width: 300px;
  }
}

@media screen and (max-width: 380px) {
  .logo img {
    max-width: 200px;
  }
}

h2 {
  text-align: center;
  margin-bottom: 10px;
  font-size: 120px;
  color: #006491;
}

p {
  text-align: center;
  font-size: 40px;
}
</style>